export default "__VITE_ASSET__Bt6EA5Po__"